import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// cn: helper untuk merge tailwind class secara aman.
// Dipakai di semua komponen shadcn dan custom — tangani precedence conflict
// (mis. "p-2 p-4" → "p-4") dan conditional class (`cn(base, isActive && "active")`).
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
